<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15zLhsG/tc-custom/9781439117781.jpg?1730546915768" alt="This image is the cover for the book Band of Angels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Band of Angels
      </h1>
      <p class="bookDescription body article font2">
        <b>A STORY OF COURAGE, PASSION, AND HEROISM SET AGAINST ONE </b><b>OF THE MOST TRAUMATIC WARS IN HISTORY</b><br/><br/>Growing up in Wales, Catherine Carreg has been allowed to run wild, spending her childhood racing ponies along the beach with her friend Deio, the cattle-driver’s son. But Catherine is consumed by a longing to escape the monotony of village life and runs away to London with Deio’s help. Alone in the unfamiliar city, Catherine secures a position in Florence Nightingale’s home for sick governesses. As the nation is gripped by reports of war in the Crimea, Catherine volunteers as a nurse—and her life changes beyond all recognition. Arriving in Scutari, she is immediately thrown into a living nightmare. Amid the madness and chaos, Catherine is forced to grow up quickly, learning the hardest lessons of love and war.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julia Gregson
      </h2>
      
      <p class="authorDescription body article">Julia Gregson has worked as a journalist and foreign correspondent in the UK, Australia, and the&#160;US.&#160;She is the author of <I>East of the Sun</I>, which was a major bestseller in the UK and won&#160;the Romantic Novel of the Year Prize and the Le Prince Maurice&#160;Prize there, and <I>Monsoon Summer</I>.&#160;Her short stories have been published in collections and magazines and read on the radio.&#160;She lives in Monmouthshire, Wales.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atria
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5b3adc22